import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

function CategoryItem({ icon, name, onClick }) {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageSrc, setImageSrc] = useState('');

  // Lazy load the category icon
  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      setImageSrc(icon);
      setImageLoaded(true);
    };
    img.src = icon;
  }, [icon]);

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <motion.button
      className="flex flex-col gap-5 justify-center items-center focus:outline-none focus:ring-2 focus:ring-sky-950 focus:ring-offset-2 rounded-lg p-2"
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      onClick={handleClick}
      aria-label={`Browse ${name} toys`}
    >
      <motion.div
        className="flex relative justify-center items-center bg-white rounded-full h-[120px] shadow-[0_19px_15px_rgba(0,0,0,0.09)] w-[120px] max-sm:w-20 max-sm:h-20"
        whileHover={{ y: -3 }}
        transition={{ duration: 0.2 }}
      >
        {!imageLoaded && (
          <div className="w-full h-full bg-gray-200 animate-pulse rounded-full flex items-center justify-center">
            <span className="text-gray-500 text-xs">Loading...</span>
          </div>
        )}

        {imageLoaded && (
          <img
            src={imageSrc}
            alt=""
            className="max-h-[72px] max-w-[90px] max-sm:max-h-12 max-sm:max-w-[60px]"
          />
        )}
      </motion.div>
      <span className="text-xl leading-8 text-center text-neutral-600 max-sm:text-base">
        {name}
      </span>
    </motion.button>
  );
}

export default CategoryItem;
